export function StageDirective($timeout, Canvas) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      canvasId: "=canvasId"
    },
    link: function (scope, element, attrs) {
      const id = attrs.canvasId;
      const canvas = element.find('canvas');
      let isLoaded = true;

      canvas.attr('id', id);

      $timeout(function () {
        if(!isLoaded) return;

        const stage = new createjs.Stage(id);
        const canvas = stage.canvas;
        stage.mouseMoveOutside = true;
        stage.enableMouseOver();

        //// grab the width and height from canvas
        //var height = canvas.getAttribute('height');
        //var width = canvas.getAttribute('width');
        //// reset the canvas width and height with window.devicePixelRatio applied
        //canvas.setAttribute('width', Math.round(width * window.devicePixelRatio));
        //canvas.setAttribute('height', Math.round(height * window.devicePixelRatio));
        //// force the canvas back to the original size using css
        //canvas.style.width = width + "px";
        //canvas.style.height = height + "px";
        //// set CreateJS to render scaled
        //stage.scaleX = stage.scaleY = window.getDevicePixelRatio();

        Canvas.setStageInitialized(stage);
      });

      scope.$on('$destroy', () => {
        isLoaded = false;
      });
    },
    template: '<canvas width="1800" height="1200" style="width: 700px; height: 466px"></canvas>'
  };
}



// WEBPACK FOOTER //
// ./client/components/canvas/stage.directive.js